var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.986,
    height: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.719 7.6a.875.875 0 0 1-.642.266.864.864 0 0 1-.635-.259l-.2-.2v5.723a.851.851 0 0 1-.253.614.834.834 0 0 1-.621.259H8.741v-3.938a.444.444 0 0 0-.441-.437H5.682a.444.444 0 0 0-.437.437V14H2.622A.834.834 0 0 1 2 13.739a.85.85 0 0 1-.252-.615V7.4l-.2.2a.864.864 0 0 1-.635.259.875.875 0 0 1-.647-.259A.875.875 0 0 1 0 6.957a.864.864 0 0 1 .259-.635L6.323.258A.865.865 0 0 1 6.993 0a.865.865 0 0 1 .669.259l6.064 6.064a.864.864 0 0 1 .259.635.875.875 0 0 1-.266.642z",
    transform: "translate(0 .002)",
    fill: "#3c2f87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.56c91e7309f2203c4579dc4abf831f7f.svg";
export { ForwardRef as ReactComponent };